import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-loading">
        <div className="flex flex-col items-center gap-3 text-slate-500">
          <Loader2 className="h-7 w-7 animate-spin text-blue-600" />
          <span className="text-sm">Loading Tax Flow…</span>
        </div>
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
